import { AmountText, Container, CouponImage, RankText, TextWrapper } from './styles'

interface PrizeTierProps {
  imageSrc: string
  rank: string
  amount: string
}

export default function PrizeTier({ imageSrc, rank, amount }: PrizeTierProps) {
  return (
    <Container>
      <CouponImage src={imageSrc} alt={`${rank} 쿠폰`} width={54.2} height={54.2} />
      <TextWrapper>
        <RankText>{rank}</RankText>
        <AmountText>{amount}</AmountText>
      </TextWrapper>
    </Container>
  )
}
